
import Layout from "@/components/layout/Layout";
import AdminDashboardHeader from "./AdminDashboardHeader";
import AdminDashboardContent from "./AdminDashboardContent";
import { useAdminDashboardData } from "@/hooks/useAdminDashboardData";

const AdminDashboard = () => {
  const {
    searchTerm,
    articles,
    filteredArticles,
    archivedArticles,
    filteredArchivedArticles,
    articleCount,
    loadingArticles,
    deleteDialog,
    handleView,
    handleEdit,
    handleOpenDelete,
    handleCloseDelete,
    handleDelete,
    handleArchive,
    handleUnarchive,
    handleSearch,
    filteredUsers,
  } = useAdminDashboardData();

  return (
    <Layout>
      <div className="py-8 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AdminDashboardHeader />
          <AdminDashboardContent
            articleCount={articleCount}
            searchTerm={searchTerm}
            onSearch={handleSearch}
            articles={articles}
            filteredArticles={filteredArticles}
            archivedArticles={archivedArticles}
            filteredArchivedArticles={filteredArchivedArticles}
            loadingArticles={loadingArticles}
            deleteDialog={deleteDialog}
            onView={handleView}
            onEdit={handleEdit}
            onOpenDelete={handleOpenDelete}
            onCloseDelete={handleCloseDelete}
            onDelete={handleDelete}
            onArchive={handleArchive}
            onUnarchive={handleUnarchive}
            filteredUsers={filteredUsers}
          />
        </div>
      </div>
    </Layout>
  );
};

export default AdminDashboard;
